import { MicrofrontendEvent } from '../../../Microfrontend';

import { IAppEvent } from './types';

export const createAppEvent = (isMicrofrontend: boolean): IAppEvent => ({
  onCheckServiceChange(data) {
    if (isMicrofrontend) {
      MicrofrontendEvent.sendChangeServicesEvent(data);
    }
  },

  onCheckServiceStatusChange(data) {
    if (isMicrofrontend) {
      MicrofrontendEvent.sendCheckServiceStatusChangeEvent(data);
    }
  },

  onPublicationUnavailableReasonChange(data) {
    if (isMicrofrontend) {
      MicrofrontendEvent.sendPublicationUnavailableEvent(data);
    }
  },
});
